
    import * as React from 'react';

    const Next20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Next_20_svg__Icons/Next/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M16.6483713,9.9796283 L10.6746043,4.8592566 L11.3253957,4.1 L18.7682954,10.4796283 L11.3253957,16.8592566 L10.6746043,16.1 L16.6483713,10.9796283 L1.5,10.9796283 L1.5,9.9796283 L16.6483713,9.9796283 Z" id="Next_20_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Next20.displayName = 'Next20';

    export default Next20;
  